import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { HBox } from '../../../../components/Box';
import { selectInvoice } from '../../../Invoices/selectors';
import { selectAddressTypes } from '../../../Address/selectors';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';

const AgreementLabel = styled(HBox)`
  width: 70%;
  margin-bottom: 10px;
  border-radius: 10px;
  justify-content: center;

  h1 {
    font-size: 38px;
    font-weight: 600;
  }

  background-color: ${props => {
    if (props.clientId == AppClientId.AUTOWIENTJES) {
      return '#102357';
    }

    if (props.clientId == AppClientId.HARRY_NIJBOER) {
      return '#AB0033';
    }
    if (props.clientId == AppClientId.HOOIKAMMER) {
      return '#3462AB';
    }

    return '#CC2027';
  }};

  color: ${props => {
    if (props.clientId == AppClientId.AUTOWIENTJES) {
      return '#fedc01';
    }

    return '#fff';
  }};
`;

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class SaleAgreementLabelComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  render() {
    return (
      <AgreementLabel clientId={env.clientId}>
        <h1>{this.props.label}</h1>
      </AgreementLabel>
    );
  }
}

SaleAgreementLabelComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  vehicle: PropTypes.object,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoice: selectInvoice(ownProps.outgoingInvoiceId),
    addressTypes: selectAddressTypes(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const SaleAgreementLabel = compose(withConnect, withRouter)(SaleAgreementLabelComp);
